/* Locale-aware plumbing (2026-08-21). Cart AJAX endpoints render their
   `sections` HTML in the locale of the REQUEST URL — a root '/cart/add.js'
   always comes back in the primary locale (English), so on /es and /de
   storefronts the drawer snapped back to English after any cart action.
   Prefix every cart call with Shopify's locale root ('/es/', '/de/', or
   '/'). __fcdT is the string table emitted by snippets/cart-drawer.liquid.
   Defined at file scope (NOT inside an IIFE): this file contains several
   IIFEs and every one of them uses these. */
var FCD_ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
function fcdT(key, fallback) {
  var t = window.__fcdT;
  return (t && t[key]) || fallback;
}

(function(){
  if (window.fcdCartInstalled) return;
  window.fcdCartInstalled = true;

  /* ─── Discount code box: collapsed behind "Have a discount code?" (2026-09-06) ───
     The snippet renders it closed unless the cart already carries a code.
     Once the shopper opens it (or starts typing — see __fcdKeepDiscountInput)
     a page-level flag keeps it open through every drawer re-render, which
     replaces the whole footer DOM. A MutationObserver re-applies the state
     the moment a fresh [data-fcd-discount] node lands. */
  function fcdDiscountApply(root) {
    var box = root || document.querySelector('[data-fcd-discount]');
    if (!box) return;
    var open = !!window.__fcdDiscountOpen || box.getAttribute('data-open') === 'true';
    var panel = box.querySelector('[data-fcd-discount-panel]');
    var toggle = box.querySelector('[data-fcd-discount-toggle]');
    if (open) box.setAttribute('data-open', 'true'); else box.removeAttribute('data-open');
    if (panel) panel.hidden = !open;
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-fcd-discount-toggle]');
    if (!btn) return;
    var box = btn.closest('[data-fcd-discount]');
    var nowOpen = !(box && box.getAttribute('data-open') === 'true');
    window.__fcdDiscountOpen = nowOpen;
    if (box) { if (nowOpen) box.setAttribute('data-open', 'true'); else box.removeAttribute('data-open'); }
    fcdDiscountApply(box);
    if (nowOpen) {
      var inp = box && box.querySelector('[data-fcd-discount-input]');
      if (inp) { try { inp.focus({ preventScroll: true }); } catch (err) {} }
    }
  });
  if (window.MutationObserver) {
    var fcdDiscObs = new MutationObserver(function (muts) {
      if (!window.__fcdDiscountOpen) return;
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var k = 0; k < added.length; k++) {
          var n = added[k];
          if (n.nodeType !== 1) continue;
          var box = n.matches && n.matches('[data-fcd-discount]') ? n : (n.querySelector && n.querySelector('[data-fcd-discount]'));
          if (box) { fcdDiscountApply(box); return; }
        }
      }
    });
    fcdDiscObs.observe(document.documentElement, { childList: true, subtree: true });
  }
  fcdDiscountApply();

  // ─── Body class toggle when cart drawer is open / closed ───
  // Dawn adds class="active" to <cart-drawer> when opening. We mirror
  // that into a body+html class `fcd-cart-open` so older browsers
  // without :has() support also get the scroll lock.
  function watchCartDrawerOpen() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) {
      // Drawer not parsed yet — try once more after a tick
      return setTimeout(watchCartDrawerOpen, 200);
    }
    function syncOpenClass(){
      var isOpen = drawer.classList.contains('active');
      document.body.classList.toggle('fcd-cart-open', isOpen);
      document.documentElement.classList.toggle('fcd-cart-open', isOpen);
    }
    syncOpenClass();
    if ('MutationObserver' in window) {
      new MutationObserver(syncOpenClass).observe(drawer, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
    // Touch escape hatch: any touchmove on the body itself (outside the
    // drawer's scrollable area) gets cancelled while drawer is open. This
    // is the belt for the scroll-lock-watchdog's defeat of position:fixed.
    document.addEventListener('touchmove', function(e){
      if (!drawer.classList.contains('active')) return;
      // Only block if the touch target isn't inside the scrollable cart area
      if (e.target.closest('cart-drawer-items, .fcd-upsell__track, .drawer__footer')) return;
      e.preventDefault();
    }, { passive: false });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchCartDrawerOpen);
  } else {
    watchCartDrawerOpen();
  }

  // ─── Optimistic (instant) line-item removal ───
  // Dawn's <cart-remove-button> binds its click handler inside the element
  // constructor, and that handler waits for BOTH /cart/change.js and the
  // section re-render before the row disappears — a 1-2s stall on a slow
  // connection. We listen in the CAPTURE phase so we run before Dawn's
  // target-phase listener, stop it, collapse the row immediately, then
  // reconcile with the server in the background.
  var fcdRemoving = Object.create(null);

  // height:auto is not animatable, so pin the measured height first and
  // force a reflow before the collapsing class lands.
  function fcdCollapseRow(row) {
    if (!row || row.classList.contains('fcd-item--removing')) return;
    row.style.height = row.offsetHeight + 'px';
    void row.offsetHeight;
    row.classList.add('fcd-item--removing');
  }

  function fcdRestoreRow(row) {
    if (!row) return;
    row.classList.remove('fcd-item--removing');
    row.style.height = '';
    // Brief flash so a failed removal isn't silent.
    row.classList.add('fcd-item--remove-failed');
    setTimeout(function(){ row.classList.remove('fcd-item--remove-failed'); }, 520);
  }

  function fcdRemoveLine(key, row) {
    if (!key || fcdRemoving[key]) return;
    fcdRemoving[key] = true;
    fcdCollapseRow(row);

    fetch(FCD_ROOT + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: key,
        quantity: 0,
        sections: 'cart-drawer,cart-icon-bubble'
      })
    })
      .then(function(r){
        if (!r.ok) throw new Error('cart change failed');
        return r.json();
      })
      .then(function(response){
        // The row is already visually gone, so this re-render is seamless.
        refreshDrawerSections(response);
      })
      .catch(function(){
        fcdRestoreRow(row);
      })
      .finally(function(){
        delete fcdRemoving[key];
      });
  }

  document.addEventListener('click', function(e){
    var btn = e.target.closest('cart-remove-button');
    if (!btn) return;
    var row = btn.closest('[data-cart-item-key]');
    // Unexpected markup — let Dawn's own handler deal with it.
    if (!row) return;

    e.preventDefault();
    e.stopPropagation();
    fcdRemoveLine(row.getAttribute('data-cart-item-key'), row);
  }, true);

  // ─── Custom qty stepper (+ / −) for cart-drawer items ───
  // Replaces Dawn's <quantity-input> client-side validation, which fires the
  // "increments of N" popover even on variants with no quantity_rule set
  // (suspect: Markets quantity rules or stale variant data). We bypass by
  // calling /cart/change.js directly with the new quantity, then re-render
  // the drawer + cart icon bubble from the response.sections payload.
  //
  // Sections requested: cart-drawer (re-renders our markup) + cart-icon-bubble
  // (refreshes the count in the header). Both are standard Dawn sections.
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-fcd-qty-btn]');
    if (!btn) return;
    var wrap = btn.closest('[data-fcd-qty]');
    if (!wrap) return;
    e.preventDefault();
    e.stopPropagation();

    // Debounce double-clicks while a request is in flight.
    if (wrap.hasAttribute('data-fcd-qty-loading')) return;
    wrap.setAttribute('data-fcd-qty-loading', 'true');

    var input = wrap.querySelector('[data-fcd-qty-val]');
    var key   = wrap.getAttribute('data-item-key');
    var dir   = btn.getAttribute('data-fcd-qty-dir');
    var cur   = parseInt(input.value, 10) || 1;
    var next  = dir === 'plus' ? cur + 1 : Math.max(0, cur - 1);

    // Optimistic UI update so the button feels responsive.
    input.value = next;

    // Stepping "−" down from 1 removes the line. Make that feel identical to
    // the remove button: collapse the row now, reconcile after the response.
    var qtyRow = wrap.closest('[data-cart-item-key]');
    if (next === 0) fcdCollapseRow(qtyRow);

    fetch(FCD_ROOT + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: key,
        quantity: next,
        sections: 'cart-drawer,cart-icon-bubble'
      })
    })
      .then(function(r) { return r.json(); })
      .then(function(response) {
        refreshDrawerSections(response);
        // header bubble + listeners
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: response }));
      })
      .catch(function() {
        // Rollback the optimistic update on failure.
        input.value = cur;
        if (next === 0) fcdRestoreRow(qtyRow);
      })
      .finally(function() {
        wrap.removeAttribute('data-fcd-qty-loading');
      });
  });

  /* renderContents replaces the drawer's DOM wholesale — including the
     discount-code input. A shopper halfway through typing or pasting their
     sign-up code lost the text AND the keyboard focus whenever anything
     re-rendered the drawer (quantity change, upsell add, background cart
     refresh): on a phone that reads as "the drawer won't let me enter the
     code". Capture the input's state before every re-render and put it back
     into the freshly rendered input afterwards. (2026-08-13) */
  window.__fcdKeepDiscountInput = function (renderFn) {
    var inp = document.querySelector('[data-fcd-discount-input]');
    var saved = null;
    if (inp && (inp.value || document.activeElement === inp)) {
      /* Renders come in BURSTS (our refresh, then Dawn's own re-render, then
         reconciliation) and Dawn's focus trap steals focus between them — so
         by the second render the input is no longer focused and a naive
         capture would stop restoring. Persist the typing intent with a short
         TTL instead: any render inside the window keeps pulling focus back. */
      var focusedNow = document.activeElement === inp;
      var intent = Date.now() < (window.__fcdDiscountFocusUntil || 0);
      /* Typing in the box counts as opening it — the collapsed-by-default
         panel (2026-09-06) must come back OPEN after this re-render or the
         restored text would sit inside a hidden input. */
      window.__fcdDiscountOpen = true;
      if (focusedNow) window.__fcdDiscountFocusUntil = Date.now() + 2500;
      /* Event-driven guard alongside the timers: Dawn's focus trap grabs
         focus via focusin on its container at unpredictable times, so a
         polling window alone loses some races. Whenever focus lands on a
         non-interactive surface (the drawer shell / body) while the typing
         TTL is live, bounce it straight back. If the shopper deliberately
         focuses a real control, honour it and end the TTL. */
      if (focusedNow && !window.__fcdFocusGuard) {
        window.__fcdFocusGuard = true;
        document.addEventListener('focusin', function (e) {
          if (Date.now() >= (window.__fcdDiscountFocusUntil || 0)) return;
          var t = e.target;
          if (t && t.matches && t.matches('[data-fcd-discount-input]')) return;
          var benign = t && t.matches && t.matches('.drawer__inner, cart-drawer, #CartDrawer, body');
          if (!benign) { window.__fcdDiscountFocusUntil = 0; return; }
          var f = document.querySelector('[data-fcd-discount-input]');
          if (f) { try { f.focus({ preventScroll: true }); } catch (err) {} }
        });
      }
      saved = {
        value: inp.value,
        focused: focusedNow || intent,
        selStart: inp.selectionStart, selEnd: inp.selectionEnd
      };
    }
    renderFn();
    if (!saved) return;
    [0, 120, 320, 650, 1100, 1800].forEach(function (delay) {
      setTimeout(function () {
        var fresh = document.querySelector('[data-fcd-discount-input]');
        if (!fresh) return;
        if (fresh.value !== saved.value && !fresh.value) fresh.value = saved.value;
        var wantFocus = saved.focused && Date.now() < (window.__fcdDiscountFocusUntil || 0);
        if (wantFocus && document.activeElement !== fresh) {
          try {
            fresh.focus({ preventScroll: true });
            fresh.setSelectionRange(saved.selStart, saved.selEnd);
          } catch (e) {}
        }
      }, delay);
    });
  };

  // ─── Helper: re-render drawer + cart icon bubble after a cart change ───
  function refreshDrawerSections(response) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && response && response.sections && typeof drawer.renderContents === 'function') {
      window.__fcdKeepDiscountInput(function () { drawer.renderContents(response); });
      // Mirror the fix from feedback_dawn_drawer_is_empty: renderContents
      // doesn't strip is-empty from the wrapper, so the drawer stays in
      // empty-state CSS unless we clean it up manually.
      drawer.classList.remove('is-empty');
    } else if (drawer && typeof drawer.open === 'function') {
      drawer.open();
    }
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: response }));
  }

  // ─── Upsell carousel: arrow navigation ───
  document.addEventListener('click', function(e){
    var prevBtn = e.target.closest('[data-fcd-upsell-prev]');
    var nextBtn = e.target.closest('[data-fcd-upsell-next]');
    if (!prevBtn && !nextBtn) return;
    var wrapper = (prevBtn || nextBtn).closest('[data-fcd-upsell]');
    if (!wrapper) return;
    var track = wrapper.querySelector('[data-fcd-upsell-track]');
    if (!track) return;
    var card = track.querySelector('.fcd-upsell__card');
    if (!card) return;
    var step = card.getBoundingClientRect().width + 12; // 12 = gap
    track.scrollBy({ left: nextBtn ? step : -step, behavior: 'smooth' });
  });

  // ─── Empty-state "Shop by model" scroller arrows (2026-08-21) ───
  document.addEventListener('click', function(e){
    var prevBtn = e.target.closest('[data-fcd-models-prev]');
    var nextBtn = e.target.closest('[data-fcd-models-next]');
    if (!prevBtn && !nextBtn) return;
    var wrap = (prevBtn || nextBtn).closest('.fcd-empty__models-wrap');
    var track = wrap && wrap.querySelector('[data-fcd-models-track]');
    if (!track) return;
    var tile = track.querySelector('.fcd-empty__model');
    if (!tile) return;
    var step = (tile.getBoundingClientRect().width + 8) * 2; // 8 = gap, jump 2 tiles
    track.scrollBy({ left: nextBtn ? step : -step, behavior: 'smooth' });
  });

  // ─── Upsell add: POST /cart/add.js with selected variant, then re-render ───
  document.addEventListener('click', function(e){
    var addBtn = e.target.closest('[data-fcd-upsell-add]');
    if (!addBtn) return;
    if (addBtn.hasAttribute('disabled')) return;
    e.preventDefault();

    var card = addBtn.closest('.fcd-upsell__card');
    var variantId = addBtn.dataset.defaultVariant;
    if (!addBtn.hasAttribute('data-single-variant') && card) {
      var sel = card.querySelector('[data-fcd-upsell-variant]');
      if (sel && sel.value) variantId = sel.value;
    }
    if (!variantId) return;

    var originalLabel = addBtn.textContent;
    addBtn.setAttribute('disabled', 'disabled');
    addBtn.textContent = fcdT('adding', 'Adding…');

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    formData.append('sections', 'cart-drawer,cart-icon-bubble');

    fetch(FCD_ROOT + 'cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function(r){ return r.json(); })
      .then(function(response){
        // Chain /cart.js for accurate item count (cart/add.js doesn't return it)
        return fetch(FCD_ROOT + 'cart.js').then(function(r){ return r.json(); }).then(function(cart){
          response.item_count = cart.item_count;
          response.total_price = cart.total_price;
          return response;
        }).catch(function(){ return response; });
      })
      .then(function(response){
        refreshDrawerSections(response);
        // After re-render the button is a different DOM node; restore text
        // on whatever button is now in the same card position. No-op if gone.
      })
      .catch(function(){
        addBtn.removeAttribute('disabled');
        addBtn.textContent = originalLabel || fcdT('add', 'Add');
      });
  });

  // ─── Discount code: apply via /discount/CODE, then re-render drawer ───
  function discountMsg(wrapper, text, ok) {
    var msg = wrapper.querySelector('[data-fcd-discount-msg]');
    if (!msg) return;
    msg.textContent = text || '';
    msg.classList.toggle('fcd-discount__msg--ok', !!ok);
    if (text) { msg.removeAttribute('hidden'); } else { msg.setAttribute('hidden', ''); }
  }

  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-fcd-discount-apply]');
    if (!btn) return;
    if (btn.hasAttribute('disabled')) return;
    e.preventDefault();

    var wrapper = btn.closest('[data-fcd-discount]');
    var input = wrapper && wrapper.querySelector('[data-fcd-discount-input]');
    var code = (input && input.value || '').trim();
    if (!code) {
      discountMsg(wrapper, fcdT('enter_code', 'Please enter a discount code.'), false);
      return;
    }
    // Register as a MANUALLY entered code before the request goes out, so
    // the manual-only enforcement below never races against it.
    if (window.__fcdRememberManualCode) window.__fcdRememberManualCode(code);

    var originalLabel = btn.textContent;
    btn.setAttribute('disabled', 'disabled');
    btn.textContent = fcdT('applying', 'Applying…');
    discountMsg(wrapper, '', false);

    /* Modern flow (2026-08-13). The old implementation hit GET /discount/<code>
       to set a cookie, then re-rendered and GUESSED whether the code worked.
       That endpoint is exactly the fragile kind: it 401s through the theme-dev
       proxy, it is the kind of XHR Cloudflare likes to challenge (the iOS
       reload-loop pattern), and validity was a heuristic - an invalid code
       produced "Code accepted - check totals" with no change, or worse.

       The Cart AJAX API now takes the code directly: POST /cart/update.js with
       `discount` applies it AND answers with discount_codes[].applicable, so
       validity is a fact, not a guess. One round trip, sections rendered in
       the same response, nothing for an edge proxy to intercept.

       `discount` REPLACES the cart's whole code set, so the previously
       applicable codes are read first and always resubmitted with the new
       one - a failed second code can never silently strip a working first
       one. */
    fetch(FCD_ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var prior = (cart.discount_codes || [])
          .filter(function (d) { return d.applicable; })
          .map(function (d) { return d.code; })
          .filter(function (c) { return c.toUpperCase() !== code.toUpperCase(); });

        var fd = new FormData();
        fd.append('discount', prior.concat(code).join(','));
        fd.append('sections', 'cart-drawer,cart-icon-bubble');
        return fetch(FCD_ROOT + 'cart/update.js', {
          method: 'POST',
          body: fd,
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
        }).then(function (r) { return r.json(); }).then(function (updated) {
          return { updated: updated, prior: prior };
        });
      })
      .then(function (res) {
        var updated = res.updated;
        var entry = (updated.discount_codes || []).filter(function (d) {
          return d.code && d.code.toUpperCase() === code.toUpperCase();
        })[0];
        var ok = !!(entry && entry.applicable);

        btn.removeAttribute('disabled');
        btn.textContent = originalLabel || fcdT('apply', 'Apply');

        if (ok) {
          refreshDrawerSections(updated);
          if (input) input.value = '';
          // renderContents may have replaced the wrapper node.
          var fresh = document.querySelector('[data-fcd-discount]');
          if (fresh) {
            discountMsg(fresh, fcdT('applied', 'Discount applied \u2713'), true);
            setTimeout(function () { discountMsg(fresh, '', false); }, 4500);
          }
        } else {
          // Invalid for this cart — it's not a "manual" code after all.
          if (window.__fcdForgetManualCode) window.__fcdForgetManualCode(code);
          // Drop the dud so checkout never nags about an invalid code, while
          // resubmitting the shopper's previously working codes untouched.
          var restore = new FormData();
          restore.append('discount', res.prior.join(','));
          fetch(FCD_ROOT + 'cart/update.js', {
            method: 'POST',
            body: restore,
            headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
          }).catch(function () {});
          discountMsg(wrapper, fcdT('invalid', "This code isn't valid for your cart."), false);
        }
      })
      .catch(function () {
        btn.removeAttribute('disabled');
        btn.textContent = originalLabel || fcdT('apply', 'Apply');
        discountMsg(wrapper, fcdT('failed', 'Could not apply the code. Please try again.'), false);
      });
  });

  // Enter key in discount input → click Apply
  document.addEventListener('keydown', function(e){
    if (e.key !== 'Enter') return;
    if (!e.target.matches || !e.target.matches('[data-fcd-discount-input]')) return;
    e.preventDefault();
    var wrapper = e.target.closest('[data-fcd-discount]');
    var applyBtn = wrapper && wrapper.querySelector('[data-fcd-discount-apply]');
    if (applyBtn) applyBtn.click();
  });

  // ──────────────────────────────────────────────────────────────────────
  // Cart-drawer price reconciliation (2026-06-15)
  // ──────────────────────────────────────────────────────────────────────
  // Shopify sometimes renders the cart-drawer section BEFORE finalizing
  // all discount calculations — most commonly when an automatic discount
  // is a non-BXGY type (e.g. "Amount off products") combined with a BXGY.
  // The discount IS computed and shows at checkout, but the cart-drawer
  // Liquid render misses it. /cart.js (called separately) has the correct
  // discount data. This script fetches /cart.js after every drawer update
  // and patches any line items whose DOM shows the wrong price.
  //
  // Why patch the DOM instead of forcing a re-render: a re-render via
  // /cart/update.js often returns the same stale render. Patching the
  // already-rendered DOM is faster and guaranteed to take effect.
  // ──────────────────────────────────────────────────────────────────────

  // Money formatter — uses Shopify's exact money format string baked in at
  // render time from shop.money_format. Handles every Shopify amount token:
  // {{ amount }}, {{ amount_no_decimals }}, {{ amount_with_comma_separator }},
  // {{ amount_no_decimals_with_comma_separator }}, {{ amount_with_apostrophe_separator }}.
  // Falls back to a plain $X.XX format if the Liquid token isn't a recognized one.
  var FCD_MONEY_FORMAT = window.FCD_MONEY_FORMAT || '';
  function fcdMoney(cents){
    cents = parseInt(cents, 10) || 0;
    // Market-correct path. Falls through to the token substitution below if
    // the snippet somehow didn't render, so the worst case is the previous
    // behaviour rather than a missing price.
    if (typeof window.fcMoney === 'function') {
      try { return window.fcMoney(cents); } catch (e) {}
    }
    var amount = cents / 100;
    var amountStr = amount.toFixed(2);
    var amountNoDec = Math.round(amount).toString();
    var amountWithComma = amount.toFixed(2).replace('.', ',');
    var amountNoDecWithComma = amountNoDec;
    var amountWithApostrophe = amount.toFixed(2).replace('.', '.').replace(/\B(?=(\d{3})+(?!\d))/g, "'");
    var formatted = (FCD_MONEY_FORMAT || '${{amount}}')
      .replace(/\{\{\s*amount\s*\}\}/g, amountStr)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountWithComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecWithComma)
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, amountWithApostrophe);
    // Safety: if the format string didn't contain any recognised amount token
    // and our output is still missing the number, fall back to plain $X.XX so
    // the customer never sees a bare "$" without a value.
    if (formatted.indexOf(amountStr) === -1 && formatted.indexOf(amountNoDec) === -1 && formatted.indexOf(amountWithComma) === -1) {
      formatted = '$' + amountStr;
    }
    return formatted;
  }

  function fcdPatchPrices(){
    fetch(FCD_ROOT + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        if (!cart || !Array.isArray(cart.items)) return;
        var drawer = document.querySelector('cart-drawer');
        if (!drawer) return;

        cart.items.forEach(function(item){
          // Find the rendered line item by Shopify line key
          var dom = drawer.querySelector('.fcd-item[data-cart-item-key="' + item.key + '"]');
          if (!dom) return;
          var priceCol = dom.querySelector('.fcd-item__pricecol');
          if (!priceCol) return;

          var original = item.original_line_price || 0;
          var finalPrice = item.final_line_price || 0;
          var hasDiscount = original > finalPrice;
          var hasStrikeInDom = !!priceCol.querySelector('.fcd-item__old-price');


          if (hasDiscount) {
            // Always patch to ensure correct rounding (Liquid's integer-truncate
            // division was rounding 39.98 down to 39 instead of up to 40).
            var savedPct = Math.round(((original - finalPrice) / original) * 100);
            priceCol.innerHTML =
              '<p class="fcd-item__old-price">' + fcdMoney(original) + '</p>' +
              '<p class="fcd-item__price fcd-item__price--discounted">' + fcdMoney(finalPrice) + '</p>' +
              (savedPct > 0 ? '<span class="fcd-item__save-badge">' + ((window.__fcdT && window.__fcdT.save) || 'SAVE') + ' ' + savedPct + '%</span>' : '');
          } else if (!hasDiscount && hasStrikeInDom) {
            // Inverse: render has a strikethrough but cart has no discount.
            // Patch back to single-price display.
            priceCol.innerHTML = '<p class="fcd-item__price">' + fcdMoney(finalPrice) + '</p>';
          }
        });
      })
      .catch(function(){});
  }

  // Run reconciliation on:
  //   1. Initial page load (after a small delay, to wait for any cart fetch)
  //   2. Any cart-drawer DOM update (detected via MutationObserver)
  //   3. Cart drawer open/close (events Dawn emits, plus a few custom ones)

  var fcdReconcileTimer = null;
  function fcdScheduleReconcile(delay){
    clearTimeout(fcdReconcileTimer);
    fcdReconcileTimer = setTimeout(fcdPatchPrices, delay || 300);
  }

  // Initial reconciliation
  if (document.readyState === 'complete') {
    fcdScheduleReconcile(500);
  } else {
    window.addEventListener('load', function(){ fcdScheduleReconcile(500); }, { once: true });
  }

  // Watch the cart-drawer for any DOM changes (item added/removed/updated/replaced).
  // Debounced to avoid running on every minor mutation.
  function fcdAttachObserver(){
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.__fcdObserved) return;
    drawer.__fcdObserved = true;
    var obs = new MutationObserver(function(){ fcdScheduleReconcile(150); });
    obs.observe(drawer, { childList: true, subtree: true });
  }
  fcdAttachObserver();
  // Re-attach if drawer is re-mounted later
  setInterval(fcdAttachObserver, 2000);

})();

/* ── Wrong-model protection in the cart drawer (2026-08-07) ────────────
   Same goal as the bundle fix: stop shoppers accidentally buying an
   accessory for a different phone than the case they're buying.

   1. UPSELL PRE-SELECT — the "Essential kits" cards default their variant
      dropdown to the newest model. If the cart already tells us which
      phone the shopper owns, pre-select THAT model instead (and point the
      Add button at it), so the default action is the correct one.
   2. MISMATCH FLAG — if a line in the cart is for a different model than
      the rest, show an amber note on that line. Detection only; we never
      silently change what someone deliberately added.

   Model option names are matched in every storefront language, mirroring
   snippets/fc-option-kind.liquid. */
(function () {
  var COLOR_TOKENS = ['color', 'colour', 'farbe', 'couleur', 'colore', 'kleur', '\u30ab\u30e9\u30fc', '\u8272', 'm\u00e0u'];
  var MODEL_TOKENS = ['model', 'modell', 'mod\u00e8le', 'modele', 'modello', 'modelo', '\u30e2\u30c7\u30eb', '\u6a5f\u7a2e', 'm\u1eabu', 'phone', 'device', 'telefon', 't\u00e9l\u00e9phone', 'telefono', 'handy', 'ger\u00e4t'];

  function norm(v) {
    return String(v || '').toLowerCase()
      .replace(/samsung/g, '').replace(/galaxy/g, '')
      .replace(/[^a-z0-9]/g, '');
  }
  function isModelName(name) {
    var lc = String(name || '').toLowerCase();
    for (var i = 0; i < COLOR_TOKENS.length; i++) if (lc.indexOf(COLOR_TOKENS[i]) > -1) return false;
    for (var j = 0; j < MODEL_TOKENS.length; j++) if (lc.indexOf(MODEL_TOKENS[j]) > -1) return true;
    return false;
  }
  // Model value of a /cart.js line, or '' when the product has no model option.
  function lineModel(item) {
    var opts = item.options_with_values || [];
    for (var i = 0; i < opts.length; i++) {
      if (isModelName(opts[i].name)) return opts[i].value;
    }
    return '';
  }

  function apply(cart) {
    if (!cart || !cart.items || !cart.items.length) return;

    // Reference model = the CASE in the cart, not a popularity vote.
    // A 1-case + 1-accessory cart is a tie by count, and the accessory can
    // sort first — which made the warning blame the case. product_type
    // separates them cleanly ("Hinge Cover Case Z Fold" vs "Accessories
    // Z Fold"); price is the tie-breaker when type is blank.
    function isCaseLine(it) {
      return /case/i.test(it.product_type || '') || /case/i.test(it.product_title || '');
    }
    var refModel = '', refLabel = '', refPrice = -1;
    cart.items.forEach(function (it) {
      var m = lineModel(it);
      if (!m || !isCaseLine(it)) return;
      var price = it.final_price || it.price || 0;
      if (price > refPrice) { refPrice = price; refModel = norm(m); refLabel = m; }
    });
    if (!refModel) {
      // No case in the cart — fall back to the priciest model-bearing line.
      cart.items.forEach(function (it) {
        var m = lineModel(it);
        if (!m) return;
        var price = it.final_price || it.price || 0;
        if (price > refPrice) { refPrice = price; refModel = norm(m); refLabel = m; }
      });
    }
    if (!refModel) return;
    var best = refModel;
    var labels = {};
    labels[best] = refLabel;

    // 1. Point every upsell card at the shopper's model.
    document.querySelectorAll('[data-fcd-upsell-variant]').forEach(function (sel) {
      var matched = null;
      for (var i = 0; i < sel.options.length; i++) {
        var txt = norm(sel.options[i].textContent);
        // variant titles read "Galaxy Z Fold 7 / Black" -> compare the model part
        if (txt.indexOf(best) === 0 || txt === best) { matched = sel.options[i]; break; }
      }
      if (matched) {
        sel.value = matched.value;
        var card = sel.closest('.fcd-upsell__card');
        var btn = card && card.querySelector('[data-fcd-upsell-add]');
        if (btn) btn.setAttribute('data-default-variant', matched.value);
      }
    });

    // 2. Flag any line that doesn't match the dominant model.
    cart.items.forEach(function (it) {
      var row = document.querySelector('[data-cart-item-key="' + it.key + '"]');
      if (!row) return;
      var old = row.querySelector('[data-fcd-model-warn]');
      if (old) old.remove();
      var m = lineModel(it);
      if (!m || norm(m) === best) return;

      var warn = document.createElement('p');
      warn.setAttribute('data-fcd-model-warn', '');
      warn.style.cssText = 'margin:4px 0 0;font-size:11px;line-height:1.35;color:#b45309;background:#fff7ed;border:1px solid rgba(217,119,6,.28);border-radius:8px;padding:5px 8px;display:flex;gap:5px;align-items:flex-start;';
      warn.innerHTML = '<span aria-hidden="true">\u26a0</span><span>' + fcdT('warn_a', 'This one is for') + ' <strong>' + m +
        '</strong> \u2014 ' + fcdT('warn_b', 'the rest of your order is') + ' <strong>' + (labels[best] || '') + '</strong>.</span>';
      var body = row.querySelector('.fcd-item__body') || row;
      var variantLine = body.querySelector('.fcd-item__variant');
      if (variantLine && variantLine.parentNode) variantLine.parentNode.insertBefore(warn, variantLine.nextSibling);
      else body.appendChild(warn);
    });
  }

  function refresh() {
    fetch(FCD_ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(apply)
      .catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  else refresh();
  // Re-run after the drawer re-renders (add/remove/qty change).
  document.addEventListener('cart:updated', function () { setTimeout(refresh, 250); });
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-fcd-upsell-add], cart-drawer, .fcd-item')) setTimeout(refresh, 700);
  }, true);
})();

/* ── Open + refresh the drawer on ANY add-to-cart (2026-08-07) ─────────
   The drawer HTML is server-rendered once per page load. Paths that add
   via /cart/add.js WITHOUT asking for `sections` (the bundle CTA, sticky
   cart, model guard, third-party apps) left the drawer showing whatever
   it rendered with — which, on a fresh page, is the empty state. Adding a
   bundle then opening the cart showed "Your cart is empty".

   One global hook covers every path instead of patching each caller:
   watch fetches to /cart/add.js, then re-render the drawer from the
   server and slide it open. */
(function () {
  if (window.__fcDrawerAutoOpen) return;
  window.__fcDrawerAutoOpen = true;

  window.FCDrawer = window.FCDrawer || {};

  // Paint the drawer from already-rendered section HTML. Shared by the
  // fast path (sections came back inside the add response) and the
  // fallback refresh (sections fetched separately).
  function renderSections(sections, shouldOpen) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') {
      var doRender = function () { drawer.renderContents({ sections: sections }); };
      if (typeof window.__fcdKeepDiscountInput === 'function') window.__fcdKeepDiscountInput(doRender);
      else doRender();
      // renderContents leaves the stale is-empty class behind, which keeps
      // the empty-state CSS (and hides the item list) even with items present.
      drawer.classList.remove('is-empty');
    }
    if (shouldOpen && drawer && typeof drawer.open === 'function') {
      try { drawer.open(); } catch (e) {}
    }
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { sections: sections } }));
  }
  window.FCDrawer.renderSections = renderSections;

  var pending = null;
  window.FCDrawer.refresh = function (shouldOpen) {
    clearTimeout(pending);
    // The 80ms debounce only exists to coalesce bursts on this fallback
    // path; the fast path below never waits.
    pending = setTimeout(function () {
      fetch(FCD_ROOT + '?sections=cart-drawer,cart-icon-bubble', {
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) { return r.json(); })
        .then(function (sections) { renderSections(sections, shouldOpen); })
        .catch(function () {});
    }, 80);
  };

  /* Fast path (2026-08-13). The old flow was two serial server round-trips:
     POST /cart/add.js, wait, then GET /?sections=... and only then open the
     drawer — measured at ~2.3s click-to-open through the dev proxy. The Cart
     AJAX API can render those sections INSIDE the add response: inject
     `sections` into the outgoing request body here (one place covers every
     caller — PDP form, bundle, sticky cart, grid modal, drawer upsell), and
     paint straight from the response. One round trip, no debounce.

     Injection is strictly best-effort: FormData and JSON-object bodies are
     amended, anything else is left untouched and the fallback refresh covers
     it. If injection or response parsing fails in any way, behaviour is
     exactly the old two-step flow — never worse. */
  var SECTIONS = 'cart-drawer,cart-icon-bubble';
  function injectSections(init) {
    if (!init || !init.body) return;
    try {
      if (init.body instanceof FormData) {
        if (!init.body.has('sections')) {
          /* sections only — NO sections_url. Shopify's MULTIPART parser
             rejects sections_url with "must be a relative path" even for
             valid values (urlencoded/JSON accept the same value), and real
             browser FormData is always multipart: every add returned 400 on
             live, whose error path alert() froze the page. The fallback
             refresh always rendered these sections against '/' anyway, so
             omitting the URL is the long-established behaviour. 2026-08-13 */
          init.body.append('sections', SECTIONS);
        }
      } else if (typeof init.body === 'string' && init.body.charAt(0) === '{') {
        var parsed = JSON.parse(init.body);
        if (parsed && !parsed.sections) {
          parsed.sections = SECTIONS;
          init.body = JSON.stringify(parsed);
        }
      }
    } catch (e) { /* leave the body untouched; fallback path handles it */ }
  }

  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function (input, init) {
      var url = '';
      try { url = (typeof input === 'string') ? input : (input && input.url) || ''; } catch (e) {}
      var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
      if (isAdd) injectSections(init);
      /* Locale root rewrite: other callers (PDP form, bundle, sticky cart)
         fetch root '/cart/add.js', whose `sections` render in the primary
         locale. Rewriting the string URL onto FCD_ROOT keeps the drawer in
         the storefront language. Request objects are left untouched. */
      if (isAdd && FCD_ROOT !== '/' && typeof input === 'string' &&
          input.charAt(0) === '/' && input.indexOf(FCD_ROOT) !== 0) {
        input = FCD_ROOT + input.slice(1);
        arguments[0] = input;
      }
      var result = nativeFetch.apply(this, arguments);
      if (isAdd) {
        result.then(function (res) {
          if (!res || !res.ok) return;
          // Clone so the caller's own res.json() still works.
          res.clone().json()
            .then(function (data) {
              if (data && data.sections) {
                clearTimeout(pending);           // cancel any queued fallback
                renderSections(data.sections, true);
              } else {
                window.FCDrawer.refresh(true);
              }
            })
            .catch(function () { window.FCDrawer.refresh(true); });
        }).catch(function () {});
      }
      return result;
    };
  }
})();

/* Instant feedback on the checkout button (2026-08-13). Delegated on
   document so it survives renderContents replacing the drawer DOM. The
   class is presentation-only: the native submit proceeds untouched, and
   pageshow clears it if the shopper comes BACK from checkout via bfcache. */
(function () {
  if (window.__fcdCheckoutFeedback) return;
  window.__fcdCheckoutFeedback = true;
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('cart-drawer [name="checkout"]');
    if (btn && !btn.disabled) btn.classList.add('fcd-going');
  }, true);
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('cart-drawer [name="checkout"].fcd-going')
      .forEach(function (b) { b.classList.remove('fcd-going'); });
  });
})();

/* ── Manual-only discount codes (2026-08-15) ──────────────────────────
   Sign-up flows (Klaviyo wheel/email links via /discount/CODE) attach
   the code to the cart automatically, so the drawer showed a discounted
   checkout total before the shopper typed anything. Store policy: a
   code counts ONLY when entered in the drawer's discount box. Any
   cart-level code the shopper didn't type there is stripped, and the
   /discount/ cookie is expired so checkout doesn't resurrect it.
   Automatic discounts (e.g. the BOGO 50%) are not codes — unaffected. */
(function () {
  if (window.__fcdManualDiscountOnly) return;
  window.__fcdManualDiscountOnly = true;

  function manualCodes() {
    try { return JSON.parse(sessionStorage.getItem('fcdManualCodes') || '[]'); }
    catch (e) { return []; }
  }
  function saveCodes(list) {
    try { sessionStorage.setItem('fcdManualCodes', JSON.stringify(list)); } catch (e) {}
  }
  window.__fcdRememberManualCode = function (code) {
    var c = String(code || '').trim().toUpperCase();
    if (!c) return;
    var list = manualCodes();
    if (list.indexOf(c) === -1) { list.push(c); saveCodes(list); }
  };
  window.__fcdForgetManualCode = function (code) {
    var c = String(code || '').trim().toUpperCase();
    saveCodes(manualCodes().filter(function (x) { return x !== c; }));
  };

  var busy = false;
  function enforce() {
    if (busy) return;
    fetch(FCD_ROOT + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var codes = (cart && cart.discount_codes || []).map(function (d) { return d.code; });
        if (!codes.length) return;
        var allowed = manualCodes();
        var keep = codes.filter(function (c) {
          return allowed.indexOf(String(c).toUpperCase()) !== -1;
        });
        if (keep.length === codes.length) return; // every code was hand-typed
        busy = true;
        // Expire Shopify's discount cookie so checkout doesn't re-add it.
        document.cookie = 'discount_code=; Max-Age=0; path=/';
        var fd = new FormData();
        fd.append('discount', keep.join(','));
        fd.append('sections', 'cart-drawer,cart-icon-bubble');
        return fetch(FCD_ROOT + 'cart/update.js', {
          method: 'POST',
          body: fd,
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
        })
          .then(function (r) { return r.json(); })
          .then(function (updated) {
            if (updated && updated.sections && window.FCDrawer && typeof window.FCDrawer.renderSections === 'function') {
              // Repaint totals; never pop the drawer open for this.
              window.FCDrawer.renderSections(updated.sections, false);
            }
          })
          .catch(function () {})
          .then(function () { busy = false; });
      })
      .catch(function () {});
  }

  if (document.readyState === 'complete') setTimeout(enforce, 800);
  else window.addEventListener('load', function () { setTimeout(enforce, 800); }, { once: true });
  // Re-check after every cart change (add/remove/qty all re-render the drawer).
  document.addEventListener('cart:updated', function () { setTimeout(enforce, 400); });
})();
